import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import { Form } from "react-bootstrap";
import Pagination from "@mui/material/Pagination";
import NotificationGrid from "./NotificationGrid";
import NotificationApi from "../../api/NotificationApi";
import AuthService from "../../session/AuthService";
import IconButton from "@mui/material/IconButton";
import TuneIcon from "../../Icons/TuneIcon";
import NotificationFilterModal from "./NotificatonFilterModal";
import { FiXCircle } from "react-icons/fi";

class NotificationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationList: [],
      totalCount: 0,
      totalPageno: 0,
      pageNo: 0,
      search: "",
      currentPage: 1,
      openFilterModal: false,
      filterkey: "",
      filterType: "",
    };
  }

  componentDidMount() {
    this.togetAllNotificationData();
  }

  togetAllNotificationData = () => {
    let obj = {
      page: 0,
      search: "",
      receiverId: parseInt(AuthService.getUserId()),
      filterkey: "",
    };

    NotificationApi.getNotificationforAdmin(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        this.setState({
          notificationList: response.data.data.notificationList,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };

  render() {
    return (
      <>
        <div className="Heading" style={{ paddingTop: "20px" }}>
          <NavigationChange
            Topics={"Notification"}
            numberofRecord={this.state.totalCount}
            specficwidth={"140"}
            back={true}
          />
        </div>
        <div className="row" id="titleWithDropdowns">
          <div className="title-column-notification">
            <div className="search-contain ">
              <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

              <div className="search">
                <span className="fa fa-search" onClick={this.search}></span>
                <input
                  type="text"
                  placeholder="Type Here..."
                  name="search"
                  value={this.state.search}
                  onKeyPress={this.handleKeyPress}
                  onChange={this.searchvalue}
                />
              </div>
            </div>
            <div className="search-contain">
              <span style={{ fontSize: "17px" }}>
                {"Filter "}
                {this.state.filterType !== "" && (
                  <Form.Label style={{ fontSize: "17px" }}>
                    {"BY"} {this.state.filterType}
                  </Form.Label>
                )}
              </span>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  aria-label="filter"
                  onClick={this.handleFilterClick}
                  size="medium"
                  sx={{ mr: 1, backgroundColor: "#d9d9d9" }}
                >
                  <TuneIcon className="custom-icon" />
                </IconButton>
              </div>
            </div>

            <div className="search-contain">
              <div></div>
              {this.state.filterType !== "" && (
                <>
                  <Form.Label style={{ fontSize: "17px" }}>
                    Clear Filter{" "}
                  </Form.Label>

                  <div
                    onClick={this.clearfilter}
                    style={{ paddingTop: "5px", paddingLeft: "20px" }}
                  >
                    <FiXCircle style={{ fontSize: "25px" }} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <NotificationGrid
          OpenModal={this.OpenCreateTask}
          notificationList={this.state.notificationList}
        />

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageno}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>
        {this.state.openFilterModal && (
          <NotificationFilterModal
            show={this.state.openFilterModal}
            handleClose={this.closeFilterModal}
            filterdata={(e) => this.getfilterValue(e)}
            clearfilter={this.togetAllTaskdata}
            getfilterType={(a) => this.getfilterType(a)}
          />
        )}
      </>
    );
  }

  getfilterType = (a) => {
    this.setState(
      {
        filterType: a,
      },
      () => {
        console.log("filtertype", this.state.filterType);
      }
    );
  };

  clearfilter = () => {
    this.setState(
      {
        page: 0,
        search: "",
        filterkey: "",
        filterType: "",
      },
      () => {
        let obj = {
          page: 0,
          search: "",
          receiverId: parseInt(AuthService.getUserId()),
          filterkey: "",
        };
        NotificationApi.getNotificationforAdmin(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.setState({
              notificationList: response.data.data.notificationList,
              totalCount: response.data.data.totalCount,
              totalPageno: response.data.data.totalPageno,
            });
          }
        });
      }
    );
  };

  getfilterValue = (e) => {
    console.log("e in parent page", e);

    this.setState(
      {
        filterValue: e,
      },
      () => {
        let obj = {
          page: 0,
          search: this.state.search,
          receiverId: parseInt(AuthService.getUserId()),
          filterkey: this.state.filterValue,
        };
        NotificationApi.getNotificationforAdmin(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.setState({
              notificationList: response.data.data.notificationList,
              totalCount: response.data.data.totalCount,
              totalPageno: response.data.data.totalPageno,
            });
          }
        });
      }
    );
  };

  handleFilterClick = () => {
    this.setState({
      openFilterModal: true,
    });
  };

  closeFilterModal = () => {
    this.setState({
      openFilterModal: false,
    });
  };

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      page: 0,
      search: this.state.search,
      receiverId: parseInt(AuthService.getUserId()),
      filterkey: "",
    };
    NotificationApi.getNotificationforAdmin(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        this.setState({
          notificationList: response.data.data.notificationList,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        page: this.state.pageNo,
        search: this.state.search,
        receiverId: parseInt(AuthService.getUserId()),
        filterkey: "",
      };
      NotificationApi.getNotificationforAdmin(obj).then((response) => {
        if (response.data && response.data.message === "success") {
          this.setState({
            notificationList: response.data.data.notificationList,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    });
  };
}
export default NotificationContainer;
